
export default {
    name: 'LeeImgEffect',
    data() {
        return {
            bg: this.config,
            cur: 0,
            whichclass: 'my-enter-active',
            whichclasst: 'change-enter-active',
            sw: 0,
            totalw: 0,
            setint: '',
            theeffect:''
        }
    },
    methods: {
        prev() {
            var _this=this
            clearInterval(this.setint)
            if (this.theeffect == 'slideleft') {
                this.cur -= 1
                this.setint = setInterval(this.add, 5000);
            } else {
                this.whichclasst = 'change-leave-active'
                this.whichclass = 'my-leave-active'
                setTimeout(function() {
                    _this.whichclasst = 'change-enter-active'
                    _this.whichclass = 'my-enter-active'
                    _this.cur -= 1
                }, 700)
                this.setint = setInterval(this.addf, 5000);
            }

        },
        next() {
            var _this=this
            clearInterval(this.setint)
            if (this.theeffect == 'slideleft') {
                this.cur += 1
                this.setint = setInterval(this.add, 5000);
            } else {
                this.whichclasst = 'change-leave-active'
                this.whichclass = 'my-leave-active'
                setTimeout(function() {
                    _this.whichclasst = 'change-enter-active'
                    _this.whichclass = 'my-enter-active'
                    _this.cur += 1
                }, 200)
                this.setint = setInterval(this.addf, 5000);
            }
        },
        add() {
            this.cur += 1
        },
        addf() {
            var _this = this
            this.whichclasst = 'change-leave-active'
            this.whichclass = 'my-leave-active'
            setTimeout(function() {
                _this.whichclasst = 'change-enter-active'
                _this.whichclass = 'my-enter-active'
                _this.cur += 1
            }, 200)
        },
    },
    mounted() {
        var _this = this
        if (this.theeffect === 'change') {
            var img = document.querySelector('.fade').children
            this.setint = setInterval(this.addf, 5000)
        } else if (this.theeffect === 'slideleft') {
            var slideleft = document.querySelector('.slideleft')
            var ul = slideleft.children
            var sw = slideleft.scrollWidth
            var totalw = sw * _this.bg.length
            this.sw = sw
            this.totalw = totalw
            ul[1].style.cssText = "width:" + totalw + "px"
            this.setint = setInterval(this.add, 5000)

        }
    },
    props: {
        config: {
            type: Array,
            default () {
                return []
            }
        },
        effect: {
            type: String,
            default: 'accordion'
        },
        height: {
            type: String,
            default: '300px'
        }
    },
    watch: {
        cur: {
            immediate: true,
            handler(value) {
                if (value > this.bg.length - 1) {
                    this.cur = 0
                } else if (value < 0) {
                    this.cur = this.bg.length - 1
                }
            }
        },
        effect: {
            immediate: true,
            handler(value) {
                let types=['accordion','change','slideleft','ninegrid']
                let fi=types.filter(function(el) {
                    return el.indexOf(value)>-1;
                })
                if(fi.length<1){
                    this.theeffect="accordion"
                }else{
                    this.theeffect=value
                }
            }
        },
    }
};
